<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">Circuit Discounts</h1>
      <v-spacer></v-spacer>
      <v-col class="py-0">
        <list-filters
          :filters="filters"
          label="Find Circuit Discount"
          ref-name="cd_list_filters"
          @searchParamsChanged="onFiltersChange"
          :expansionPanel="false"
        ></list-filters>
      </v-col>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" fab dark color="primary" @click="onCreateNew">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create New Circuit Discount</span>
      </v-tooltip></v-row
    >
    <v-row>
      <v-col class="pa-0">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          :search="search"
          fixed-header
          :height="gridHeight"
          v-bind="pagingOptions"
          hide-default-footer
        >
          <template v-slot:item.validFrom="{ item }">{{
            item.validFrom | formatDate
          }}</template>
          <template v-slot:item.validTo="{ item }">{{
            item.validTo | formatDate
          }}</template>
          <template v-slot:item.bookAfter="{ item }">{{
            item.bookAfter | formatDate
          }}</template>
          <template v-slot:item.bookBy="{ item }">{{
            item.bookBy | formatDate
          }}</template>
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hide-view
              @deleteItem="onDeleteItem"
              @editItem="onEditItem"
            >
            </default-list-actions>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <get-more-results
      :first="first"
      @limitChange="onLimitChange"
      :items="circuitDiscounts"
      :totalItems="totalItems"
      :loading="$apollo.loading"
      :loadMoreEnabled="loadMoreEnabled"
      @loadMore="loadMore('circuitDiscounts')"
    ></get-more-results>
    <edit-circuit-discount-dialog
      :show="showEditDialog"
      v-model="editedItem"
      @close="showEditDialog = false"
      @input="onSaveItem"
    />
    <v-row v-if="debug">
      <v-col>
        <code>{{ gridHeight }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { ListMixin } from "../../../../mixins/ListMixin";

import { removeGQLTypename } from "../../../../helpers";
import DefaultListActions from "../../shared/DefaultListActions.vue";
import EditCircuitDiscountDialog from "./EditCircuitDiscountDialog.vue";
import ListFilters from "../../shared/list-filters/ListFilters.vue";
import listFilters from "./list-filters";
import GetMoreResults from "../../shared/GetMoreResults.vue";
const LIST_QUERY = gql`
  query circuitDiscountsList(
    $filter: CircuitDiscountFilterType
    $after: String
    $sort: SortOrderType
    $first: Int
  ) {
    circuitDiscounts(
      first: $first
      after: $after
      filter: $filter
      orderBy: $sort
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          validFrom
          validTo
          bookBy
          bookAfter
          description
          days
          minStay
          maxStay
          minSuppliers
          maxSuppliers
          maxStay
          percent
          percentCost
          free
          groupId
          agentGroupName
          tagsList
        }
      }
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateCircuitDiscount($input: CircuitDiscountInput!) {
    updateCircuitDiscount(input: $input) {
      id
      validFrom
      validTo
      bookBy
      bookAfter
      description
      days
      minStay
      maxStay
      minSuppliers
      maxSuppliers
      maxStay
      percent
      percentCost
      free
      groupId
      agentGroupName
      tagsList
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createCircuitDiscount($input: CircuitDiscountInput!) {
    createCircuitDiscount(input: $input) {
      id
      validFrom
      validTo
      bookBy
      bookAfter
      description
      days
      minStay
      maxStay
      minSuppliers
      maxSuppliers
      maxStay
      percent
      percentCost
      free
      groupId
      agentGroupName
      tagsList
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deleteCircuitDiscount($id: ID!) {
    deleteCircuitDiscount(id: $id) {
      id
    }
  }
`;
export default {
  name: "circuit-discount-list",

  mixins: [ListMixin],

  components: {
    DefaultListActions,
    EditCircuitDiscountDialog,
    ListFilters,
    GetMoreResults,
  },

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "Description",
          value: "description",
          name: "description",
        },
        {
          text: "Tags",
          value: "tagsList",
          name: "tagsList",
        },
        {
          text: "Min Suppliers",
          value: "minSuppliers",
          name: "minSuppliers",
        },
        {
          text: "Max Suppliers",
          value: "maxSuppliers",
          name: "maxSuppliers",
        },
        {
          text: "Min Stay",
          value: "minStay",
          name: "minStay",
        },
        {
          text: "Max Stay",
          value: "maxStay",
          name: "maxStay",
        },
        {
          text: "Cost %",
          value: "percentCost",
          name: "percentCost",
        },
        {
          text: "Sell %",
          value: "percent",
          name: "percent",
        },
        /*{
          text: "Free",
          value: "free",
          name: "free",
        },*/
        {
          text: "Iti Created From",
          value: "bookAfter",
          name: "bookAfter",
        },
        {
          text: "Iti Created To",
          value: "bookBy",
          name: "bookBy",
        },
        {
          text: "Days",
          value: "days",
          name: "days",
        },
        {
          text: "Valid From",
          value: "validFrom",
          name: "validFrom",
        },
        {
          text: "Valid To",
          value: "validTo",
          name: "validTo",
        },
        {
          text: "Agent Group",
          value: "agentGroupName",
          name: "agentGroupName",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
        },
      ],
      editedItem: null,
      showEditDialog: false,
      windowHeight: window.innerHeight,
    };
  },

  computed: {
    gridHeight() {
      return this.items && this.items.length >= 10
        ? this.windowHeight - 200
        : null;
    },
    items() {
      return this.circuitDiscounts && this.circuitDiscounts.edges
        ? this.circuitDiscounts.edges.map(removeGQLTypename)
        : [];
    },
    filters() {
      return listFilters.map((f) => {
        f.props.outlined = this.$store.getters.localSettings("outlinedInputs");
        return f;
      });
    },
  },

  methods: {
    onFiltersChange(payload) {
      this.searchParams = { ...payload };
    },
    onCreateNew() {
      this.editedItem = null;
      this.showEditDialog = true;
    },
    onEditItem(item) {
      this.editedItem = { ...item };
      this.showEditDialog = true;
    },
    async onSaveItem(payload) {
      const mutation = payload.id ? UPDATE_MUTATION : CREATE_MUTATION;
      try {
        await this.$apollo.mutate({
          mutation: mutation,
          variables: { input: payload },
          refetchQueries: [
            {
              query: LIST_QUERY,
            },
          ],
        });
        this.$store.dispatch("showAppSnackbar", {
          msg: "Circuit Discount Saved.",
        });
        this.showEditDialog = false;
      } catch (error) {
        console.log(error);
        const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },
    async onDeleteItem(payload) {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: payload.id,
          },
          refetchQueries: [
            {
              query: LIST_QUERY,
              variables: {
                first: this.first,
                filter: this.searchParams,
              },
            },
          ],
        });
        this.$store.dispatch("showAppSnackbar", {
          msg: "Circuit Discount deleted",
        });
      } catch (error) {
        const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },
  },

  apollo: {
    circuitDiscounts: {
      query: LIST_QUERY,
      variables() {
        return {
          first: this.first,
          filter: this.searchParams,
        };
      },
      result({ data }) {
        this.totalItems = data.circuitDiscounts.totalCount;
        //  this.pagination.totalItems = data.itineraries.totalCount;
      },
      fetchPolicy: "network-only",
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight;
    });
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/plugins/circuit-discounts/CircuitDiscountList.vue